export default "__VITE_ASSET__BXe9l5YX__"